/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of conditional rule.
 */
export enum FormRuleType {
    IS_RESTRICTED_TO = 'IsRestrictedTo',
    REQUIRES_REVIEW = 'RequiresReview',
    REQUIRES_APPROVAL = 'RequiresApproval',
}
